import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { authActions } from '../../store/authSlice';
import { useSelector } from 'react-redux';
import { darkModeActions } from '../../store/darkModeSLice';
import './Header.css';

const Header = () => {
  const dispatch = useDispatch();
  const isAuth = useSelector(state => state.auth);
  const isLoggedIn = isAuth.isLoggedIn;

  const premium = useSelector(state => state.premium);
  const isPremium = premium.isPremium;

  const navigate = useNavigate();
  
  const logoutHandler = () => {
    dispatch(authActions.logout());
    navigate('/');
  };

  const darkModeHandler = () => {
    dispatch(darkModeActions.toggleDarkMode());
  };

  return (
    <div>
      <Navbar expand="lg" className="navbar">
        <Container>
          <h1 className='header-title'>Expense Tracker</h1>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto nav-links">
              <Nav.Link as={Link} to="/">Home</Nav.Link>
              <Nav.Link as={Link} to="/products">Products</Nav.Link>
              <Nav.Link as={Link} to="/about">About Me</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
        {isPremium && <Button onClick={darkModeHandler} className="dark-mode-btn">Toggle Dark Mode</Button>}
        {isLoggedIn && (
          <div className="user-actions">
            <Nav.Link as={Link} to="/updateprofile">
              <Button className='complete-profile-button'>Complete Profile</Button>
            </Nav.Link>
            <Button variant="danger" className="logout-btn" onClick={logoutHandler}>Logout</Button>
          </div>
        )}
      </Navbar>
    </div>
  );
}

export default Header;
